import React from 'react';
import { useTranslation } from '@pascal/pascal-core';
import { useIdsGenerator } from '../../hooks/useIdsGenerator';

const fairnessTextKeys = [
  'FAIRNESS_P1',
  '56256939E58A146CBBF6FD3B2583D5026EE2D2D5B41B54D70D0C5E929C9A4CF65CB0434240F9D2BC84F7159648853EE8293EF28A8B926BDBD64BCFF199044949',
  'FAIRNESS_P2',
  'FAIRNESS_P3',
  'FAIRNESS_P4',
  'FAIRNESS_P5',
  'FAIRNESS_P6',
  'FAIRNESS_P7',
  'FAIRNESS_P8',
  'FAIRNESS_P9',
  'FAIRNESS_P10',
  '258658_5,1.2,4.8,1,2_Fishing_386ed997-a025-44cc-9d82-bac3a62e221',
  'FAIRNESS_P11',
  '56256939E58A146CBBF6FD3B2583D5026EE2D2D5B41B54D70D0C5E929C9A4CF65CB0434240F9D2BC84F7159648853EE8293EF28A8B926BDBD64BCFF199044949',
  'FAIRNESS_P12',
];

const forSelectIndexes = { 1: 1, 11: 11, 13: 13 };

export function AboutHash({ scrollRef }) {
  const burnedIds = useIdsGenerator(fairnessTextKeys);
  const t = useTranslation();

  return (
    <div className='new-fishing-modal-par-holder' ref={scrollRef || null}>
      {fairnessTextKeys.map((item, index) => (
        <p
          key={burnedIds[index]}
          className={`new-fishing-modal-par ${forSelectIndexes[index] ? 'selectable' : ''}`}
        >
          {t(item)}
        </p>
      ))}
    </div>
  );
}
